import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Theme from './theme';

export { Theme };

/* IE Helpers ===== */
export const cssIEGridSupportColumns = css`
  > div:nth-of-type(1) {
    -ms-grid-column: 1;
  }
  > div:nth-of-type(2) {
    -ms-grid-column: 2;
  }
  > div:nth-of-type(3) {
    -ms-grid-column: 3;
  }
`;

export const cssIEGridSupportRows = css`
  > div:nth-of-type(1) {
    -ms-grid-row: 1;
  }
  > div:nth-of-type(2) {
    -ms-grid-row: 2;
  }
  > div:nth-of-type(3) {
    -ms-grid-row: 3;
  }
`;

export const browserIE =
  '@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none)';
/* ===== IE Helpers */

export const Grid = styled.div`
  display: -ms-grid;
  display: grid;

  -ms-grid-columns: ${(props) => props.gridTemplateColumns};
  grid-template-columns: ${(props) => props.gridTemplateColumns};
  -ms-grid-rows: ${(props) => props.gridTemplateRows};
  grid-template-rows: ${(props) => props.gridTemplateRows};

  @media (max-width: ${Theme.mobile.mobileBreakpointWidth}px) {
    ${(props) =>
      props.responsiveTemplateColumns
        ? `grid-template-columns: ${props.responsiveTemplateColumns}`
        : ''};
    ${(props) =>
      props.responsiveTemplateRows
        ? `grid-template-rows: ${props.responsiveTemplateRows}`
        : ''};
  }
`;

export const cssWordBreak = css`
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

export const cssRemoveInputFocus = css`
  :focus {
    outline: none;
  }
`;

export const Button = styled.button`
  background-color: ${(props) => (props.bgColor ? props.bgColor : '#fff')};
  border-radius: 4px;
  border: solid 1px
    ${(props) => (props.color ? props.color : Theme.colors.line)};
  color: ${(props) => (props.color ? props.color : Theme.colors.mediumText)};
  font-size: 14px;
  padding: 10px 0;
  width: 120px;
  cursor: pointer;

  i {
    margin-right: 10px;
  }

  @media (max-width: ${Theme.mobile.mobileBreakpointWidth}px) {
    font-size: 13px;
    padding: 8px 24px;
  }

  opacity: ${(props) => (props.disabled ? '0.4' : '1')};

  ${cssRemoveInputFocus};
`;

export const HR = styled.hr`
  border: none;
  background: #e6e6e6;
  height: 1px;
  outline: none;
  margin: 10px 0;
`;

export const TruncatedGradient = styled.div`
  content: '';
  position: absolute;
  width: 100%;
  height: ${(props) => (props.height ? `${props.height}px` : '50px')};
  left: 0;
  bottom: ${(props) => (props.bottom ? `${props.bottom}px` : '0')};
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 1) 100%
  ); /* FF3.6+ */
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(50%, rgba(255, 255, 255, 0)),
    color-stop(100%, rgba(255, 255, 255, 1))
  ); /* Chrome,Safari4+ */
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 1) 100%
  ); /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 1) 100%
  ); /* Opera 11.10+ */
  background: -ms-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 1) 100%
  ); /* IE10+ */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 1) 100%
  ); /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 ); /* IE6-9 */
`;
